import { INITIAL_MAX_ITEMS_TO_RETURN } from '../actions/loadConversation';
export default function createEmptyConversationItemParts(conversationId, conversationSortOrder) {
    var newConversationItemParts = {
        conversationId: conversationId,
        conversationNodeIds: [],
        conversationSortOrder: conversationSortOrder,
        canLoadMore: false,
        isLoadMoreInProgress: false,
        maxItemsToReturn: INITIAL_MAX_ITEMS_TO_RETURN,
        loadingState: { isLoading: false },
        canDelete: null /* Must initialize with null so mobx tracks changes */,
    };
    return newConversationItemParts;
}
//# sourceMappingURL=createEmptyConversationItemParts.js.map